export const excludedPaths:string[] = [
    "/properties-v2",
    "/protein-info",
    "/",
    "/pdb/prep",
    "/mol-viewer",
    "/models/diffmol",
    "/ligand",
    "/docking",
    "/models/automol",
    "user/login",
    "/user/signup",
    "/promiscuity",
    "/genie",
    "/pricing",
    "/chemlets",
    "/lab",
    "/properties-v3",
    "/chemlets/editor",
    "/editor",
    "/lift",
    "/r-groups",
    "/screenie",
    "/leader",
    "/virtual-screening",
    "/molbench-copilot",
    "/adme",
    "/molecule-design",
    "/lab/custom-mol-viewer",
  ];

export const navItems:string[] = ["Home", "About", "Contact"];